import React, { useEffect } from 'react';
import { useState } from 'react';
import { useQuery } from 'react-query';
import {
  Redirect,
  Route,
  Link as RouterLink,
  Switch,
  useHistory,
} from 'react-router-dom';

import {
  AppBar,
  Box,
  Divider,
  Drawer,
  Hidden,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Theme,
  Toolbar,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { createBrowserHistory } from 'history';

import LogoConnectionLost from '../assets/img/connection_lost.png';

import { myProducts } from '../services/products/products.service';

import CustomBreadcrumbs from '../components/Bradcrumbs/Breadcrumbs.component';

import { useNavigationContext } from '../context/Navigation/navigation.provider';
import SelfInspectionDataProvider from '../context/SelfInspection/selfInspection.provider';
import SinisterInspectionsProvider from '../context/SinisterInspections/SinisterInspections.provider';
import AssistanceDataProvider from '../context/assistance/assistance.provider';
import { useAuthDataContext } from '../context/auth/auth.provider';
import EndorsementsDataProvider from '../context/endorsements/endorsements.provider';
import IncidentsProvider from '../context/incidents/incidents.provider';
import { useNotificationsDataContext } from '../context/notifications/notifications.provider';
import { useSidebarContext } from '../context/sidebar/sidebar.provider';
import { useVehiclesContext } from '../context/vehicles/vehicles.provider';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../query/vehicles/vehicles';
import { useRouteNavigationStore } from '../stores/Navigation/route-navigation.store';
import { linkedRoutes, routes } from './routes/private.routes';

// fix me: add less width when isMobile
const DRAWER_WIDTH = 300;

let crumbs = [];
const arrOfActives = [];

const CustomRoute = (componentProps: any) => {
  let flag = false;

  const newRoute = {
    component: componentProps?.component?.name || '',
    location: componentProps?.location?.pathname || '',
  };

  const setLastRouteVisited = useRouteNavigationStore(
    (state) => state.setLastRouteVisited
  );

  setLastRouteVisited(newRoute); // this save the actual & last visited url
  const { embed } = useAuthDataContext();

  return componentProps.redirect ? (
    <Redirect from={componentProps.path} to={componentProps.redirect} />
  ) : (
    <Route
      path={componentProps.path}
      render={
        (props) => {
          crumbs = routes
            // Get all routes that contain the current one.
            .filter(({ path, root }) => {
              return props.match.path.includes(path);
            })
            // Swap out any dynamic routes with their param values.
            // E.g. "/pizza/:pizzaId" will become "/pizza/1"
            .map(({ path, hasOwnBradcrumb, ...rest }, index) => {
              let obj = {
                path: path,
                isActive: props.match.path === path ? true : false,
                hasBeenActive: true,
                ...rest,
              };
              flag = hasOwnBradcrumb ? true : false;
              if (path !== arrOfActives[arrOfActives.length - 1]?.path) {
                if (arrOfActives.some((crumb) => crumb.path === path)) {
                  return obj;
                }
                arrOfActives.push(obj);
              }
              return {
                path: path,
                isActive: props.match.path === path ? true : false,
                hasBeenActive: index !== 0 && crumbs[index - 1],
                ...rest,
              };
            });
          return (
            <>
              {!flag && !embed && componentProps.path !== '/dashboard' ? (
                <CustomBreadcrumbs
                  crumbs={arrOfActives}
                  isWorkflow={false}
                  activePath={props.match.path}
                ></CustomBreadcrumbs>
              ) : null}
              <componentProps.component
                {...props}
                {...componentProps}
                crumbs={crumbs}
              />
            </>
          );
        }
        // pass the sub-routes down to keep nesting
      }
    />
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  heightFHD: {
    minHeight: '85vh',
  },
  heightSM: {
    minHeight: '75vh',
  },
  heightXS: {
    minHeight: '75vh',
  },
  ListItemText: {
    padding: '15px',
    color: '#666666',
    // color: 'white',
  },
  listItem: {
    // marginBottom: '10px',
  },
  list: {
    padding: '15px',
  },
  drawer: {
    // [theme.breakpoints.up('sm')]: {
    //   width: DRAWER_WIDTH,
    //   flexShrink: 0,
    // },
  },
  appBar: {
    // [theme.breakpoints.up('sm')]: {
    //   width: `calc(100% - ${DRAWER_WIDTH}px)`,
    //   marginLeft: DRAWER_WIDTH,
    // },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  drawerPaper: {
    color: '#666666',
    // color: 'white',
    background: '#FFF',
    // background: '#0033A0',
    width: DRAWER_WIDTH,
    zIndex: 0,
  },
  content: {
    // maxWidth: `calc(100% - ${DRAWER_WIDTH}px)`,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      // marginBottom: '110px',
      overflow: 'auto',
    },
    flexGrow: 1,
    position: 'relative',
  },
  contentStepper: {
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      overflow: 'auto',
    },
    flexGrow: 1,
    position: 'relative',
  },
}));

const noConectionStyles = makeStyles((theme: Theme) => ({
  root: {
    background: theme.palette.error.main,
  },
}));

const PrivateRoute = () => {
  const { onLogout } = useAuthDataContext();
  const { open, setOpen, isStepper, selected, setSelected } =
    useSidebarContext();
  const { cleanNotifications } = useNotificationsDataContext();
  const { userEnabled } = useVehiclesContext();
  const [isConnected, setConnected] = useState(true);

  const classes = useStyles();
  const browserHistory = createBrowserHistory();
  let history = useHistory();
  const noConectionClasses = noConectionStyles();
  const { user } = useAuthDataContext();
  const { updateNavigation } = useNavigationContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesFHD = useMediaQuery(theme.breakpoints.up('xl'));
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const [listProducts, setListProducts] = useState('');
  const [productsFiltered, setProductsFiltered] = useState([]);
  const [classHeight, setClassHeight] = useState(null);

  const { data } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    window.addEventListener('online', () => setConnected(true));
    window.addEventListener('offline', () => setConnected(false));

    return () => {
      window.removeEventListener('online', () => setConnected(true));
      window.removeEventListener('offline', () => setConnected(false));
    };
  }, []);

  useEffect(() => {
    if (matchesFHD) {
      setClassHeight(classes.heightFHD);
    } else if (matchesXS) {
      setClassHeight(classes.heightXS);
    } else {
      setClassHeight(classes.heightSM);
    }
  }, [
    matchesFHD,
    matches,
    matchesXS,
    classes.heightFHD,
    classes.heightXS,
    classes.heightSM,
  ]);

  useEffect(() => {
    return () => {
      cleanNotifications();
    };
  }, [cleanNotifications]);

  const handlePush = async (title, url) => {
    if (title === '/account') {
      await updateNavigation({
        title,
        url,
      });
    } else {
      history.push(url);
    }
  };

  useEffect(() => {
    getMyProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMyProducts = async () => {
    await myProducts().then((productsDataList) => {
      setListProducts(productsDataList.data);
      setProductsFiltered(
        productsDataList.data.filter((product) => product.code == 4)
      );
    });
  };

  const drawer = (
    <div>
      <Box className={classes.toolbar}>
        <Typography variant="h4">
          {user?.first_name || user?.last_name || ''}
        </Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon style={{ color: '#666666' }} />
        </IconButton>
      </Box>
      <List className={classes.list}>
        {/* 
        ///////////////////////
        Cuando no tiene autos mostrar:
        Mis polizas
        Mis pagos
        Preguntas frecuentes
        atencion 
        ///////////////////////
        */}
        {routes
          .filter((route) => {
            if (listProducts.length < 1) {
              return (
                (!route.noDrawer && route.name === 'Cuenta') ||
                route.name === 'Inicio'
              );
            } else if (!data || data.length === 0) {
              return (
                (!route.noDrawer && route.name === 'Mis pólizas') ||
                route.name === 'Pagos' ||
                route.name === 'Cuenta' ||
                route.name === 'Inicio' ||
                route.name === 'Notificaciones'
              );
            } else {
              return !route.noDrawer;
            }
          })
          .sort((a, b) => (a.order > b.order ? 1 : -1))
          .map((route, index) =>
            !route.noDrawer ? (
              route.name === 'Grúa' &&
              !data?.some(
                (vehicle) => vehicle.assistance_provider?.phone
              ) ? null : (
                <>
                  <ListItem
                    className={classes.listItem}
                    button
                    key={index.toString()}
                    selected={selected === index}
                    onClick={() => {
                      setSelected(index);
                      setOpen(false);
                      handlePush(route.name, route.path);
                    }}
                    // component={Button}
                    // to={route.path}
                    disabled={route.name !== 'Inicio' && !userEnabled && true}
                  >
                    {/* <ListItemIcon>
                  <Box my={2}>{route.icon ? <route.icon /> : null}</Box>
                </ListItemIcon> */}
                    <ListItemText
                      primary={route.name}
                      className={classes.ListItemText}
                    />
                  </ListItem>
                  <Divider style={{ backgroundColor: '#E6E6E6' }} />
                  {/* <Divider style={{ backgroundColor: '#E6EDF44D' }} /> */}
                </>
              )
            ) : null
          )}
        {linkedRoutes.map((route, index) =>
          !route.noDrawer ? (
            <>
              <ListItem
                key={index.toString()}
                disabled={!userEnabled && true}
                component={RouterLink}
                to={!userEnabled ? '#' : route.path}
                onClick={() => setOpen(false)}
              >
                <ListItemText
                  primary={route.name}
                  className={classes.ListItemText}
                />
              </ListItem>
              <Divider style={{ backgroundColor: '#E6E6E6' }} />
              {/* <Divider style={{ backgroundColor: '#E6EDF44D' }} /> */}
            </>
          ) : null
        )}
        {/* <Divider style={{ backgroundColor: '#CCCCCC' }} /> */}
        {/* <Divider style={{ backgroundColor: '#E6EDF44D' }} /> */}
        <ListItem
          key={'out'}
          component={Link}
          onClick={() => {
            onLogout();
            // window.location.href = '/login';
            // window.location.reload();
            history.push('/');
          }}
        >
          <Link component="button">
            <ListItemText
              primary={'Cerrar sesión'}
              className={classes.ListItemText}
            />
          </Link>
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={` ${matches ? '' : classes.root} ${classHeight} `}>
      {/* <Breadcrumbs crumbs={crumbs} /> */}
      <nav aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}

        <Hidden xsUp implementation="css">
          <Drawer
            variant="temporary"
            anchor="right"
            // open={open}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            anchor="right"
            classes={{
              paper: classes.drawerPaper,
            }}
            open={open}
            onClose={handleDrawerToggle}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={isStepper ? classes.contentStepper : classes.content}>
        {!isConnected && (
          <AppBar classes={noConectionClasses} position="sticky">
            <Toolbar>
              <Box display="flex" width={'100%'} alignItems="center">
                <img src={LogoConnectionLost} alt="connection lost" />
                <Box ml={2}>
                  <Typography variant="subtitle2">No hay conexión</Typography>
                  <Typography variant="body1">
                    Por favor comprueba tu conexión Internet
                  </Typography>
                </Box>
              </Box>
            </Toolbar>
          </AppBar>
        )}

        <IncidentsProvider>
          <AssistanceDataProvider>
            <SelfInspectionDataProvider>
              <EndorsementsDataProvider>
                <SinisterInspectionsProvider>
                  <Route>
                    {/* <Route history={browserHistory}> */}
                    <Switch>
                      {routes.map((route, i) => (
                        <CustomRoute key={i} {...route} />
                      ))}
                      {linkedRoutes.map((route, i) => (
                        <CustomRoute key={i} {...route} />
                      ))}
                    </Switch>
                  </Route>
                </SinisterInspectionsProvider>
              </EndorsementsDataProvider>
            </SelfInspectionDataProvider>
          </AssistanceDataProvider>
        </IncidentsProvider>
      </main>
    </div>
  );
};

export default PrivateRoute;
